<template>
  <div>
    <div class="navbar">
      <div class="top-nav row-between mt20">
        <img
          class="cur-point header-logo"
          :src="baseUrl + sysInfo[0].logo"
          alt=""
          @click="goHome"
        />

        <div class="search-box">
          <el-select
            v-model="value"
            placeholder="请输入养老院关键词"
            clearable
            filterable
            style="width: 360px"
            @change="changeSearch"
            :filter-method="filterData"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.name"
              :value="index"
            >
            </el-option>
          </el-select>
        </div>

        <div class="right-box row">
          <img
            class="mr10"
            style="width: 36px; height: 36px"
            src="../../assets/images/nav-phone.png"
            alt=""
          />
          <span style="color: #20a3dd; font-weight: 700; font-size: 36px">{{
            sysInfo[0].phonenumber
          }}</span>
        </div>
      </div>

      <div class="row-between mt20 nav-item">
        <el-tabs
          v-model="activeName"
          stretch
          style="width: 50vw"
          @tab-click="handleClick"
        >
          <el-tab-pane label="首页" name="首页"></el-tab-pane>
          <el-tab-pane label="合作机构" name="合作机构"></el-tab-pane>
          <el-tab-pane label="健康管理" name="健康管理"></el-tab-pane>
          <el-tab-pane label="专业保险" name="专业保险"></el-tab-pane>
          <el-tab-pane label="社区论坛" name="社区论坛"></el-tab-pane>
          <el-tab-pane label="机构入驻" name="机构入驻"></el-tab-pane>
          <el-tab-pane label="会员权益" name="会员权益"></el-tab-pane>
        </el-tabs>

        <div class="btn-box">
          <template v-if="isHaveToken()">
            <img
              class="cur-point"
              :class="{ 'active-btn': activeName === '个人中心' }"
              style="width: 40px; height: 40px"
              :src="activeName !== '个人中心' ? navUserIcon : navUserIconAct"
              alt=""
              @click="userView"
            />
            <img
              class="cur-point"
              :class="{ 'active-btn': activeName === '购物车' }"
              style="width: 40px; height: 40px"
              :src="
                activeName !== '购物车' ? navShopCarIcon : navShopCarIconAct
              "
              alt=""
              @click="shopCar"
            />
          </template>
          <template v-else>
            <span class="cur-point" @click="goLogin()" style="color: #555"
              >登录</span
            >
          </template>
        </div>
      </div>

      <!-- <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" /> -->

      <!-- <breadcrumb class="breadcrumb-container" /> -->

      <!-- <div class="right-menu">
          <template v-if="device !== 'mobile'">
            <lang-select class="right-menu-item hover-effect" />
          </template>
          <el-dropdown class="avatar-container" trigger="click">
            <div class="avatar-wrapper">
              <img :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar">
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <router-link to="/">
                <el-dropdown-item>
                  Home
                </el-dropdown-item>
              </router-link>
              <a target="_blank" href="https://github.com/PanJiaChen/vue-admin-template/">
                <el-dropdown-item>Github</el-dropdown-item>
              </a>
              <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
                <el-dropdown-item>Docs</el-dropdown-item>
              </a>
              <el-dropdown-item divided @click.native="logout">
                <span style="display:block;">Log Out</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
    </div>
    <transition name="el-zoom-in-top">
      <div class="ag-b-box" v-show="agencyType">
        <div class="agency-box row wrap">
          <div
            class="agency-item cur-point text-center"
            :class="{ active: agencyCurrent == item.id }"
            v-for="(item, index) in agencyMenuImgList"
            :key="index"
            @click="agencyChoose(item.id, item.title)"
          >
            <div class="mb20">
              {{ item.title }}
            </div>
            <img :src="baseUrl + item.url" alt="" />
          </div>
        </div>
      </div>
    </transition>

    <transition name="el-zoom-in-top">
      <div class="ag-b-box" v-show="healthType">
        <div class="agency-box row wrap">
          <div
            class="agency-item cur-point text-center"
            :class="{ active: healthCurrent == item.id }"
            v-for="(item, index) in healthMenuImgList"
            :key="index"
            @click="healthChoose(item.id, item.title)"
          >
            <div class="mb10">
              {{ item.title }}
            </div>
            <img :src="baseUrl + item.url" alt="" />
          </div>
        </div>
      </div>
    </transition>

    <div
      class="agency-mask"
      v-if="agencyType || healthType"
      @click="cancelAgencyChange"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import LangSelect from "@/components/LangSelect";

import navUserIcon from "@/assets/images/nav-user-icon.png";
import navUserIconAct from "@/assets/images/nav-user-icon-active.png";

import navShopCarIcon from "@/assets/images/nav-shopCar-icon.png";
import navShopCarIconAct from "@/assets/images/nav-shopCar-icon-active.png";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device", "sysInfo"]),
  },
  data() {
    return {
      options: [],
      optionsAll: [],
      value: "",

      // icon
      navUserIcon,
      navUserIconAct,
      navShopCarIcon,
      navShopCarIconAct,

      activeName: "首页",
      // 合作机构跳转框
      agencyType: false,
      agencyCurrent: undefined,

      // 健康管理跳转
      healthType: false,
      healthCurrent: undefined,

      // menu图片
      agencyMenuImgList: [],

      healthMenuImgList: [],

      baseUrl: process.env.VUE_APP_BASE_API,
    };
  },
  watch: {
    $route: {
      handler(route) {
        this.activeName = this.$route.meta.activeTitle;
      },
      immediate: true,
    },
  },
  created() {
    this.activeName = this.$route.meta.activeTitle;

    this.init();
    this.getServerTypeAll();
  },
  methods: {
    goLogin() {
      this.$router.push("/login");
    },
    changeSearch(index) {
      const { id, type } = this.options[index];
      this.$store.commit("app/setSearchData", { id, type });
      this.$router.push(`/agency/index?id=${id}&type=${type}`);
    },
    filterData(query = "") {
      const arr = this.optionsAll.filter((item) => {
        if (item.name) {
          return item.name.includes(query);
        } else {
          return false;
        }
      });
      // console.log(arr);
      if (arr.length > 50) {
        this.options = arr.slice(0, 50);
      } else {
        this.options = arr;
      }
    },
    async getServerTypeAll() {
      // 导航下拉选项
      const res = await this.$api.getServerTypeAll();
      if (res.code == 200) {
        this.optionsAll =
          res.data?.map(({ id, navigationTitle, title }) => ({
            id,
            type: navigationTitle || "",
            name: title,
          })) ?? [];
        this.filterData();
      }
    },

    // 撤销合作机构选中
    cancelAgencyChange(type) {
      if (type) {
        this.activeName = this.$route.meta.activeTitle;
      }
      this.agencyType = false;
      this.healthType = false;
      this.agencyCurrent = undefined;
      this.healthCurrent = undefined;
      // this.agencyCurrent = undefined
    },
    // 初始化
    async init() {
      let data = await this.$api.getAgencyNavigationListApi();
      if (data) {
        let a = []; // 机构
        let b = []; // 健康管理
        let arr = data.data;
        arr.sort((c, d) => Number(c.sort) - Number(d.sort));
        arr.map((item) => {
          if (item.parentId == 1) {
            a.push(item);
          } else {
            if (item.parentId == 2 || item.parentId == 4 || item.parentId == 5 || item.parentId == 6 ) {
              b.push(item);
            }
          }
        });
        this.agencyMenuImgList = a;
        this.healthMenuImgList = b;
      }
    },

    // 个人信息页面
    userView() {
      this.cancelAgencyChange(true);
      this.activeName = "个人中心";
      // this.activeName = ''
      this.$router.push("/userInfo/index");
    },
    // 购物车
    shopCar() {
      this.cancelAgencyChange(true);
      this.activeName = "购物车";
      this.$router.push("/shopCart/shopCart");
    },

    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("logout");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    // 进入首页
    goHome() {
      this.cancelAgencyChange(true);
      this.activeName = "首页";
      this.$router.push("/");
    },
    handleClick() {
      if (this.activeName == "首页") {
        this.cancelAgencyChange();

        this.$router.push("/");
      }

      if (this.activeName == "合作机构") {
        // this.cancelAgencyChange()
        this.healthType = false;
        this.healthCurrent = undefined;

        this.agencyType = !this.agencyType;
        // this.$router.push('/agency/list')
      }

      if (this.activeName == "健康管理") {
        // this.cancelAgencyChange()
        this.agencyType = false;
        this.agencyCurrent = undefined;

        this.healthType = !this.healthType;

        // this.$router.push('/healthManager/list')
      }

      if (this.activeName == "专业保险") {
        this.cancelAgencyChange();

        this.$router.push("/insurance/index");
      }

      if (this.activeName == "社区论坛") {
        this.cancelAgencyChange();

        this.$router.push("/forum/index");
      }

      if (this.activeName == "机构入驻") {
        this.cancelAgencyChange();
        this.$router.push("/entered/index");
      }

      if (this.activeName == "会员权益") {
        this.cancelAgencyChange();

        this.$router.push("/interests/index");
      }
      // else {
      //   this.$router.push('/order_list')
      // }
    },

    // 合作机构选中
    agencyChoose(type, title) {
      this.agencyCurrent = type;
      this.$router.push({
        path: "/agency/list",
        query: {
          aType: type,
          aTitle: title,
        },
      });

      this.agencyType = false;
    },

    // 健康管理选中
    healthChoose(type, title) {
      this.healthCurrent = type;
      this.$router.push({
        path: "/healthManager/list",
        query: {
          aType: Number(type),
          aTitle: title,
        },
      });

      this.healthType = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-logo {
  width: 311px;
  height: 69px;
  border-radius: 4px;
}

::v-deep .el-tabs__item.is-active {
  border-top-left-radius: 14px;
  background: #409eff;
  color: #fff;
}

::v-deep .el-tabs__item:nth-child(2) {
  padding-left: 8px !important;
}

::v-deep .el-tabs__item {
  font-size: 16px;
  font-weight: 700;
}

.active-btn {
  background: #ddd;
  border-radius: 14px;
  box-sizing: border-box;
  padding: 10px 11px;
}

.agency-mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 40, 0.08);
  position: absolute;
  z-index: 15;
}

.ag-b-box {
  position: absolute;
  // padding-left: 15vw;
  // padding-right: 15vw;
  left: 15vw;
  z-index: 100;
  width: calc(100% - 30vw);

  .agency-box {
    min-height: 140px;
    background: #fff;
    box-sizing: border-box;
    padding: 30px;
    z-index: 100;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    width: 100%;
    overflow-x: auto;

    .agency-item {
      // margin-right: 80px;
      box-sizing: border-box;
      padding: 10px;
      flex: 0 0 23%;
      margin-left: 1%;
      margin-right: 1%;

      img {
        width: 11.5vw;
        height: 140px;
      }
    }

    .active {
      color: #20a3dd;
      font-weight: 700;
      background: #ecf5ff;
      border-radius: 10px;
    }
  }
}

.navbar {
  min-height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  padding-left: 15vw;
  padding-right: 15vw;

  .nav-item {
    position: relative;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    background: none;
  }

  ::v-deep .el-tabs__item {
    text-align: left;
  }

  ::v-deep .el-tabs__header {
    margin-bottom: 0px;
  }

  .search-box {
    width: 360px;

    ::v-deep .el-input__inner {
      border-radius: 30px;
    }
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
